import React, { useState } from "react";
import OfficeJobsGrid from "./OfficeJobsGrid";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const OfficeJobForm = () => {
  const [productEntries, setProductEntries] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
const isFormValid = productEntries.every(entry => entry.Task_Description.trim() !== '');  // formData.jobType &&

  const navigate = useNavigate();

  const handleSubmitOfficeJob = async (e) => {
    e.preventDefault();

    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment"
    );

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentUserName = localStorage.getItem("currentUserName")
      ? localStorage.getItem("currentUserName")
      : "-";

    const newJobPayload = productEntries.map((item) => ({
      CmpCode: company_code_from_local_storage,
      mode: "ENTRY",
      Job_id: 1001, //backend
      Job_entryTime: "2025-07-22T10:00:00", //backend
      Job_creatorid: currentUserName, //dynamic
      Job_salesperson: "",
      Job_account: "",
      Job_organization: "In-house",
      Job_notes: "",
      Job_country: "",
      Job_city: "",
      Job_territory: "",
      Job_area: "",
      Job_streetaddress: "",
      Job_location: "In-house",
      Job_appartment: "",
      Job_primarycontact: "",
      Job_primarycontacttitle: "",
      Job_phone: "",
      Job_isphonewhatsapp: "",
      Job_alt_phone: "",
      Job_alt_isphonewhatsapp: "",
      Job_email: "",
      Job_stage: "", //lead number need
      Job_priority: "",
      Job_status: "",
      Job_Type: "",
      Job_bookedamount: 0,
      Job_currencycode: "",
      Job_currencyrate: 1.0,
      Task_CreateTime: "2025-07-22T11:00:00", //backend
      // Task_Description: formData.jobDescription || "",
      Task_Description: item.Task_Description || "",
      Task_Group: item.task_group || "",
      // Task_AssignedTo: "emp05//",
      Task_AssignedTo: "", //backend
      // Task_Instructions: "Prepare proposal document//",
      Task_Instructions: "",
      Task_ScheduleDateTime: "2025-07-23T10:00:00",
      Task_TargetDateTime: "2025-07-25T17:00:00",
      Task_LastActionDateTime: "2025-07-21T15:30:00",
      Task_status: "Unassigned",
      Task_Comments: "",
      Task_Serial: item.Task_Serial || "",
      deptno: currentDepartmentFromLocalStorage,
    }));

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    // console.log('apiPaths_from_local_storage',apiPaths_from_local_storage)

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRM_JobRegister`;

    try {
      const response = await axios.post(apiUrl, newJobPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("response after posting new job", response);
      const data = response.data;
      console.log("data after posting new job", data);
      setOpenSubmitSnackbar(true);
      localStorage.removeItem("formData");
      setTimeout(() => {
        navigate('/jobs',{state:{jobViewFromState:'inhouseJobs'}});
      }, 800);
    } catch (err) {
      console.error("Error while posting new job", err);
      setOpenSnackbar(true);
    }

    // setOpenSubmitSnackbar(true);
  };

  const cancelOfficeJobForm = (e) => {
    e.preventDefault();

    const initialRow = {
      id: Date.now(),
      Task_Serial: 1,
      Task_Description: "",
      task_group: "",
    };
    setProductEntries([initialRow]);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    // setDuplicateItemCodeSnackbar(false);
  };

  return (
    <div>
      <OfficeJobsGrid
        productEntries={productEntries}
        setProductEntries={setProductEntries}
      />
      <div className="flex justify-between my-6 pb-0 gap-4">
        <div></div>
        <button
          type="submit"
          className={`text-white px-4 py-2 my-2 rounded w-50 ${
            isFormValid
              ? "bg-blue-500 hover:bg-blue-700"
              : "bg-gray-400 hover:bg-gray-500 cursor-not-allowed"
          }`}
          onClick={(e) => handleSubmitOfficeJob(e)}
          disabled={!isFormValid}
        >
          Submit In-house Job
        </button>
        <button
          onClick={(e) => cancelOfficeJobForm(e)}
          className="text-gray-700 bg-gray-200 hover:bg-gray-300 px-4 py-2 my-2 rounded w-50 transition"
        >
          Clear All
        </button>
      </div>
      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSubmitSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setOpenSubmitSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          In house Job Submitted Successfully!
        </MuiAlert>
      </Snackbar>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setOpenSnackbar(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          Error while Submitting In house Job !
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default OfficeJobForm;
